<template>
  <section :class="['asc-app-loading--template']">
    <asc-page-error-content title="" subtext="Retrieving User Profile">
      <span class="asc-app-loading--support-text">
        The application is retrieving your user profile information.
      </span>
    </asc-page-error-content>
  </section>
</template>

<script>
import AscPageErrorContent from '@/components/molecules/AscPageErrorContent'

export default {
  name: 'AscAppLoadingTemplate',

  components: {
    AscPageErrorContent,
  },

  props: {
    errorType: {
      type: [Number, String],
      default: null,
    },
    lastAccepted: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    termsAndConditions: {
      type: Boolean,
      default: false,
    },
    userAccepted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-app-loading {
  &--support-text {
    color: $primary-black;
    font-size: $font-size-md;
    line-height: $line-height-lrg;
    max-width: 700px;
    text-align: center;
  }

  &--template {
    background-color: $gray-100;
    height: 100%;

    &.no-nav {
      padding: 16px;
    }
  }

  &--template > .asc-page-error--section {
    width: 100%;
  }
}
</style>
